import React from 'react';
import { plantData } from '../plantData';
import './PlantSelection.css';

const PlantSelection = ({ onSelectPlant }) => {
    return (
        <div className="plant-selection-container">
            <h2>Choose a plant to grow together!</h2>
            <div className="plant-options">
                {Object.entries(plantData).map(([key, { name, images }]) => (
                    <div key={key} className="plant-option" onClick={() => onSelectPlant(key)}>
                        <img src={images[images.length - 1]} alt={name} />
                        <h3>{name}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PlantSelection;